import React from 'react';

export type OfferIconProps = React.HTMLProps<SVGSVGElement>;

export function OfferIcon({ ...props }: OfferIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
      <g id="Group_17755" data-name="Group 17755" transform="translate(-1110 -11370)">
        <g
          id="Rectangle_8234"
          data-name="Rectangle 8234"
          transform="translate(1110 11370)"
          fill="#6e50ff"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          id="Path_41561"
          data-name="Path 41561"
          d="M897.9,4445a2.036,2.036,0,0,0,1.1,1.1l1.745.72a2.036,2.036,0,0,1,1.1,2.66l-.722,1.74a2.036,2.036,0,0,0,0,1.56l.721,1.74a2.04,2.04,0,0,1,0,1.56,2.124,2.124,0,0,1-.441.66,1.981,1.981,0,0,1-.66.44l-1.744.72a2.037,2.037,0,0,0-1.1,1.1l-.723,1.75a2.069,2.069,0,0,1-1.1,1.1,2.1,2.1,0,0,1-1.556,0l-1.744-.73a2.088,2.088,0,0,0-1.555,0l-1.745.73a2.093,2.093,0,0,1-1.555,0,2.071,2.071,0,0,1-1.1-1.1L886.1,4459a2.035,2.035,0,0,0-1.1-1.1l-1.745-.72a2.037,2.037,0,0,1-1.1-2.66l.722-1.74a2.04,2.04,0,0,0,0-1.56l-.721-1.74a2.04,2.04,0,0,1,0-1.56,2.012,2.012,0,0,1,.441-.66,1.977,1.977,0,0,1,.659-.44l1.744-.72a2.04,2.04,0,0,0,1.1-1.1l.723-1.75a2.069,2.069,0,0,1,1.1-1.1,2.1,2.1,0,0,1,1.556,0l1.744.73a2.088,2.088,0,0,0,1.555,0l1.746-.72a2.032,2.032,0,0,1,2.655,1.1l.723,1.74Z"
          transform="translate(230 6930)"
          fill="currentColor"
        />
        <path
          id="Path_41562"
          data-name="Path 41562"
          d="M889,4449h.01m5.99,6h.01m.99-7-8,8m1.5-7a.5.5,0,1,1-.5-.5A.5.5,0,0,1,889.5,4449Zm6,6a.5.5,0,1,1-.5-.5A.5.5,0,0,1,895.5,4455Z"
          transform="translate(230 6930)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </g>
    </svg>
  );
}
